<template>
  <div
    class="photo-wrapper d-flex p-0"
    @click="$emit('click')">
    <p
      v-if="show"
      class="m-0">
      <img :src="src">
    </p>
    <i
      v-else
      class="far fa-image mt-3 mb-3"/>
  </div>
</template>

<script>
export default {
  name: 'PhotoContainer',
  props: {
    src: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.photo-wrapper {
  border: 1px solid $base;;
  border-radius: 10px;
  border-style: dashed;
  overflow: hidden;
  cursor: pointer;
  i {
    margin: auto;
  }
  img {
    width: 100%;
  }
}
</style>
